// extracted by mini-css-extract-plugin
export default {"content":"fOlGZ","desktop":"b79XH","buttons":"Tqr5r","hr":"q69at","content_description":"hCVCz","non_desktop":"vQUkg"};